import axios from 'axios'
const url = '/empleados/empleado'

export default {
    create(data){
        return axios.post(url, data)
    },
    index(is_active){
        return axios.get(url+`?is_active=${is_active}`)
    },
    indexConsumo(){
        return axios.get('empleados/consumo')
    },
    getMiConsumo(url){
        return axios.get(`empleados/miconsumo`)

    },
    getConsumoEmpleado(id){
        return axios.get(`empleados/consumo/${id}`)

    },
    createCliente(data) {
        return axios.post('empleados/consumo',data)
    },
    
    show(id) {
        return axios.get(`${url}/${id}`)
    },
    // Qué pasaría si se da de baja al empleado. La pantalla lo muestra antes
    // de que el usuario confirme.
    impacto(id) {
        return axios.get(`${url}/${id}/impacto`)
    },
    eliminar(id) {
        return axios.delete(`${url}/${id}?confirmar=true`)
    },
    update(data) {
        return axios.put(`${url}/${data.id}`, data)
    },
    pagarCtaCte(id_empleado) {
        return axios.get(`/comprobantes/deudaempleado/${id_empleado}`)
    },
    setActive(id_empleado, bool) {
        console.log("·saegsdgsd");
        var action = 'a'
        if (!bool){
            action = 'd'
        }
        return axios.put(`${url}/${id_empleado}`, {
            'status': action
        } )

    },

}